import React, { useState } from 'react';
import { IconButton, Badge } from '@mui/material';
import { Notifications as NotificationsIcon } from '@mui/icons-material';
import { NotificationDropdown } from './NotificationDropdown';
import { useNotifications } from '../../hooks/useNotifications';

/**
 * NotificationBell Component
 *
 * The bell icon with badge showing unread notification count.
 * - Uses NotificationContext for unread count (polling managed by context)
 * - Opens NotificationDropdown on click
 */
export const NotificationBell: React.FC = () => {
  const { unreadCount } = useNotifications();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        onClick={handleClick}
        aria-label={`${unreadCount} unread notifications`}
        sx={{
          color: 'text.secondary',
          '&:hover': {
            bgcolor: 'action.hover',
          },
        }}
      >
        <Badge
          badgeContent={unreadCount}
          color="error"
          max={99}
          invisible={!unreadCount || unreadCount <= 0}
          sx={{
            '& .MuiBadge-badge': {
              fontSize: '0.75rem',
              fontWeight: 600,
              minWidth: 20,
              height: 20,
              padding: '0 4px',
              top: 2,
              right: 2,
              backgroundColor: 'error.main',
              color: 'error.contrastText',
            },
          }}
        >
          <NotificationsIcon />
        </Badge>
      </IconButton>

      <NotificationDropdown
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      />
    </>
  );
};

export default NotificationBell;
